import routeMap from "app/routes";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { matchPath } from "react-router-dom";

const getRouteName = (pathname: string) => {
  if (!window || !window.location) return "";

  for (const route of routeMap({
    isMobile: window?.__GLOBAL_CONTEXT__?.userAgent?.isMobile,
    isPaymentCollectionPage: !!isFeatureRunningClientSide("FLIGHTS_WEB_PAYMENT_COLLECTION_NEW_PAGE"),
    isWebview: window?.__GLOBAL_CONTEXT__?.userAgent?.isWebview,
    isFlightDetailsDesktopFullPage: window?.__GLOBAL_CONTEXT__?.isFlightDetailsDesktopFullPage || false,
    isSplitBoundsAvailable: window?.__GLOBAL_CONTEXT__?.isSplitBoundsAvailable || false,
    isAlternativeSeatmap: window?.__GLOBAL_CONTEXT__?.isAlternativeSeatmap || false
  })) {
    if (matchPath(pathname, { path: route.path, exact: true })) {
      return route.name;
    }
  }

  return "";
};

export default getRouteName;
